import {
	AfterViewInit,
	ChangeDetectionStrategy,
	Component,
	computed,
	inject,
	input,
	signal,
	viewChild,
} from '@angular/core'
import { BankOfferIcon, BankOfferIcons, ShopBankOfferDto } from '@mos/api/bank/dto-client'
import { AppConfigService } from '@mos/client/shared/app-config'
import { CanvasEmitterComponent } from '@mos/client/shared/canvas/components/canvas-emitter.component'
import { EmitterConfig } from '@mos/client/shared/canvas/models/emitter.config'
import { ParticleStarDiffracted, ParticleStarGlowing } from '@mos/client/shared/canvas/models/presets'
import { randomInRange } from '@mos/shared/utils'
import { PackPlateComponent } from '../pack-plate/pack-plate.component'

@Component({
	selector: 'mos-offer-product',
	imports: [PackPlateComponent, CanvasEmitterComponent],
	templateUrl: './offer-product.component.html',
	styleUrls: ['./offer-product.component.scss', './offer-product.animations.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		'[class.no-animations]': 'isMobileApp()',
	},
})
export class OfferProductComponent implements AfterViewInit {
	isMobileApp = signal(inject(AppConfigService).isMobileApp())

	Icons = BankOfferIcons

	offer = input.required<ShopBankOfferDto>()
	icon = computed<BankOfferIcon>(() => {
		const offer = this.offer()

		// For now we don't have a specific icon for chapter pass
		if (offer.icon === BankOfferIcons.CHAPTER_PASS) {
			return BankOfferIcons.TICKET_SET
		}

		return offer.icon
	})

	private emitterConfig: EmitterConfig = {
		displayArea: { width: 200, height: 120 },
		spawnRate: 3,
		spawnArea: () => ({ x: 20, y: 12, width: 160, height: 96 }),
		velocityX: () => randomInRange(-0.005, 0.005),
		velocityY: () => randomInRange(-0.005, 0.005),
		velocityAlpha: (particle) => 1 / particle.ttl,
		initialScaleX: () => randomInRange(1, 1.3),
		initialScaleY: (particle) => particle.scaleX,
		ttl: () => randomInRange(3000, 4000),
		tint: () => '#eeffff',
	}
	protected emitter1Config: EmitterConfig = {
		...this.emitterConfig,
		...ParticleStarGlowing,
	}
	protected emitter2Config: EmitterConfig = {
		...this.emitterConfig,
		...ParticleStarDiffracted,
		spawnRate: 1,
	}

	readonly emitter1 = viewChild<CanvasEmitterComponent>('emitter1')
	readonly emitter2 = viewChild<CanvasEmitterComponent>('emitter2')

	ngAfterViewInit() {
		const emitter1 = this.emitter1()
		const emitter2 = this.emitter2()
		if (emitter1 && emitter2) {
			emitter1.burst(6, this.emitter1Config)
			emitter2.burst(2, this.emitter2Config)
		}
	}
}
